import { QueryFunction } from 'react-query';
import { getManufacturersNames } from '@services/queries/manufacturers';

type man_search = QueryFunction<
  Awaited<ReturnType<typeof getManufacturersNames>>,
  [t: 'get', t2: 'manufacturerNames', search: string]
>;
/**
 * Extract search param from query key.
 */
export function getManufacturerNamesWSearch(
  ...args: Parameters<man_search>
): ReturnType<man_search> {
  const [{ queryKey }] = args;
  return getManufacturersNames(queryKey[2]);
}
